<template>
  <div class="convite_box">
    <div class="top_content">
      <div class="top_box">
        <div class="left_img_box">
          <img :src="data.agentInfo && data.agentInfo.levelIcon" alt="">
          <span>?</span>
        </div>
        <div class="right_box">
          <div class="right_info flex-between">
            <div class="label">
              Coletável <span>{{ data.agentInfo && data.agentInfo.vaildNum }}</span>
            </div>
            <div class="btn_box flex-row">
              <div class="btn disable">
                Receber
              </div>
              <div class="btn primary" @click="jumpShare">
                Histórico
              </div>
            </div>
          </div>
          <div class="right_info flex-between">
            <div class="label">
              Modo de Agente
            </div>
            <div class="desc">
              {{ data.agentInfo && data.agentInfo.modeType }}
            </div>
          </div>
        </div>
      </div>
      <div class="center_box">
        <div class="flex-between">
          <div class="textcolor1">
            Meu Link
          </div>
          <div class="rechargeColor">
            Alterar
          </div>
        </div>
        <div class="link flex-between">
          <div class="textcolor1">
            {{ data.inviteLink }}
          </div>
          <div class="rechargeColor" @click="doCopy(data.inviteLink)">
            <i class="el-icon-copy-document copy" />
          </div>
        </div>
        <div class="textcolor1">
          Subordinados diretos &nbsp; <span>{{ data.agentInfo && data.agentInfo.regNum }}</span>
        </div>
        <div v-if="id" class="textcolor1 code">
          Código de Convite &nbsp;<span class="textcolorf">{{ data.agentInfo && data.agentInfo.id }}</span> &nbsp;
          <i class="el-icon-copy-document" @click="doCopy(id)" />
        </div>
      </div>
      <div class="bottom_box">
        <!-- <div class="link_item">
          <div class="imgbox">
            <van-icon
              class="img"
              name="share-o"
            />
          </div>
          <div class="title textcolor1">
            Partilhar
          </div>
        </div> -->
        <div v-for="item in data.promotionApp" :key="item.title" class="link_item" @click="jumpUrl(item)">
          <img :src="item.icon" alt="">
          <div class="title textcolor1">
            {{ item.name }}
          </div>
        </div>
      </div>

    </div>
    <div class="bottom_title">
      Rede do Agente
    </div>
    <linkPicSvg />
  </div>
</template>
<script>
import Fetch from '../../../utils/fetch'
import linkPicSvg from '../svg/linkPicSvg.vue'
import a1 from '../../../assets/images/agent/1.png'
import a2 from '../../../assets/images/agent/2.png'
import a3 from '../../../assets/images/agent/3.png'
import a4 from '../../../assets/images/agent/4.png'
import a5 from '../../../assets/images/agent/5.png'
import a6 from '../../../assets/images/agent/6.png'
export default {
  components: {
    linkPicSvg
  },
  data() {
    return {
      data: {},
      show: false,
      linkList: [
        {
          title: 'Facebook',
          icon: a1
        },
        {
          title: 'Telegram',
          icon: a2
        },
        {
          title: 'WhatsApp',
          icon: a3
        },
        {
          title: 'Instagram',
          icon: a4
        },
        {
          title: 'Kwai',
          icon: a5
        },
        {
          title: 'YouTuBe',
          icon: a6
        },
      ]
    }
  },
  computed: {
    id() {
      console.log(this.data?.agentInfo?.id)
      return this.data?.agentInfo?.id
    }
  },
  created() {
    this.getConviteInfo()
  },
  methods: {
    getMobileOperatingSystem() {
      var userAgent = navigator.userAgent || navigator.vendor || window.opera;
      if (userAgent.match(/iPad/i) || userAgent.match(/iPhone/i) || userAgent.match(/iPod/i)) {
        return 'IOS';
      } else if (userAgent.match(/Android/i)) {
        return 'Android';
      } else {
        return 'unknown';
      }
    },
    getConviteInfo() {
      Fetch('/agent/agentInfo').then(res => {
        this.data = res.data
      })
    },
    jumpUrl(item) {
      window.location.href = this.getMobileOperatingSystem() === 'IOS' ? item.iosUrl : item.androidUrl
    },
    doCopy(val) {
      let _this = this;
      this.$copyText(String(val)).then(
        function (e) {
          _this.$toast({
            background: "#07c160",
            message: _this.$t("复制成功"),
          });
        },
        function (e) {
          // console.log(e);
        }
      );
    },
    jumpShare() {
      // this.$router.push('/share')
      this.$emit('custom-event', { show: true });
    }
  }
}
</script>
<style lang="less">
@import '../../../assets/css/variables.less';

/deep/ .van-popup--top {
  top: 10%
}

.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-row {
  display: flex;
}

.convite_box {
  padding: 0.24rem;

  .top_content {
    background: @secondary-color;
    border-radius: 8px;

    .top_box {
      display: flex;
      padding-right: 0.4rem;
      border-bottom: 1px solid @bodercolor;
    }

    .left_img_box {
      display: flex;
      padding: 0 0.2rem 0 0.4rem;
      align-self: baseline;
      position: relative;

      img {
        width: 1.75rem;
      }

      span {
        position: absolute;
        display: inline-block;
        width: 0.32rem;
        height: 0.32rem;
        line-height: 0.32rem;
        text-align: center;
        background-color: @rechargeColor;
        color: @primary-color;
        border-radius: 50%;
        font-size: 0.26rem;
        margin-top: 0.1rem;
        right: 0.15rem;
      }
    }

    .right_box {
      flex: 1;
      padding: 0.24rem 0 0;

      .right_info {
        margin-bottom: 0.24rem;

        .desc {
          color: @textcolorf;
          font-size: 0.28rem;
        }
      }

      .btn_box {
        .btn {
          padding: 0.18rem 0.28rem;
          border-radius: .2rem;
          font-size: 0.28rem;
          margin-left: 0.24rem;

          &.disable {
            opacity: 0.7;
            background-color: @disableColor;
            color: @textcolorf;
          }

          &.primary {
            background-color: @rechargeColor;
            color: @primary-color;
          }
        }
      }
    }

    .label {
      color: @textcolor1;
      font-size: 0.28rem;

      span {
        color: @rechargeColor;
        margin-left: 0.1rem;
      }
    }

    .center_box {
      padding: 0.24rem 0.24rem 0;

      .link {
        margin-top: 0.2rem;
        margin-bottom: 0.32rem;
        padding: 0.2rem 0.3rem;
        border-radius: 0.2rem;
        border: 1px solid @bodercolor;
      }

      .copy {
        font-size: 0.5rem;
      }

      .code {
        margin-top: 0.2rem;
        padding-bottom: 0.2rem;
      }
    }

    .bottom_box {
      display: flex;
      align-items: center;
      padding: 0.24rem;
      overflow-x: auto;

      .link_item {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: 0.3rem;
        font-size: 0.3rem;

        img {
          width: 1rem;
          height: 1rem;
          margin-bottom: 0.12rem;
          border-radius: 50%;
        }

        .imgbox {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 0.94rem;
          height: 0.94rem;
          border-radius: 50%;
          font-size: 0.6rem;
          color: @rechargeColor;
          margin-bottom: 0.12rem;
          border: 1px solid @bodercolor;
        }
      }
    }
  }

  .bottom_title {
    font-size: 0.42rem;
    color: @textcolorf;
    margin: 16px 0;
  }
}

.rechargeColor {
  color: @rechargeColor;
}

.textcolor1 {
  color: @textcolor1;
}

.textcolorf {
  color: @textcolorf;
}
</style>